module.exports = __webpack_public_path__ + "img/645.43df9c88.png";